import React, { ChangeEvent, useState } from 'react';
import { ConfirmDialog } from '../../../../components/confirm-dialog';
import { Container } from '../../../../components/container';
import { Row } from '../../../../components/row';
import { Cell } from '../../../../components/cell';
import { MaxLengthTextField } from '../../../../components/text-field';

interface ICancelLessonDialogProps {
  isOpen: boolean;
  onConfirmClick: (reason: string) => void;
  onCancelClick: () => void;
}

export function CancelLessonDialog(props: ICancelLessonDialogProps) {
  const { isOpen, onConfirmClick, onCancelClick } = props;

  const [cancellationReason, setCancellationReason] = useState<string>();
  const [cancellationReasonError, setCancellationReasonError] = useState<boolean>(false);
  function handleCancellationReasonChange(event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void {
    setCancellationReason(event.target.value);
    setCancellationReasonError(false);
  }

  function handleConfirmClick() {
    if (cancellationReason) {
      onConfirmClick(cancellationReason);
    } else {
      setCancellationReasonError(true);
    }
  }

  return (
    <ConfirmDialog type="question" title="Aflys lektion?" onConfirmClick={handleConfirmClick} open={isOpen} onCancelClick={onCancelClick} maxWidth="md">
      <Container>
        <Row>
          <Cell size="full">
            <MaxLengthTextField
              value={cancellationReason}
              label="Aflysningsårsag"
              maxLength={1000}
              variant="outlined"
              rows={5}
              required
              onChange={handleCancellationReasonChange}
              error={cancellationReasonError}
              errorText="Der skal angives en aflysningsårsag"
            />
          </Cell>
        </Row>
      </Container>
    </ConfirmDialog>
  );
}
